import apiTrainingGroups from '@/api/training-groups'
import {isEmpty, isNil, pipe, propOr, reject, unless} from 'ramda'

const state = {
  data: [],
  isLoading: false,
  error: null,
  total: null,
  lastPage: null,
}

export const mutationTypes = {
  getTrainingGroupsListStart:
    '[training groups list] Get training groups list start',
  getTrainingGroupsListSuccess:
    '[training groups list] Get training groups list success',
  getTrainingGroupsListFailure:
    '[training groups list] Get training groups list failure',
}

export const actionTypes = {
  getTrainingGroupsList: '[training groups list] Get training groups list',
}

const mutations = {
  [mutationTypes.getTrainingGroupsListStart](state) {
    state.isLoading = true
  },

  [mutationTypes.getTrainingGroupsListSuccess](state, payload) {
    if (payload.isAdd) {
      state.data = [...state.data, ...payload.list]
    } else {
      state.data = payload.list
    }

    state.total = payload.total
    state.lastPage = payload.lastPage
    state.isLoading = false
  },

  [mutationTypes.getTrainingGroupsListFailure](state) {
    state.isLoading = false
  },
}

const actions = {
  [actionTypes.getTrainingGroupsList](context, data) {
    const params = pipe(
      propOr(null, 'params'),
      unless(isNil, reject(isEmpty))
    )(data)

    const isAdd = propOr(false, 'isAdd', data)

    context.commit(mutationTypes.getTrainingGroupsListStart)
    return new Promise((resolve) => {
      apiTrainingGroups
        .trainingGroupsListForAdmin(params)
        .then((response) => {
          context.commit(mutationTypes.getTrainingGroupsListSuccess, {
            ...response.data,
            isAdd,
          })
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getTrainingGroupsListFailure)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
